<template>
  <div class="container">
    <div class="postPage" v-if="firstPage" @click="firstPage = false" @touchstart="touchstart()" @touchmove="touchmove()" @touchend="touchend()">
      <div class="leftToRight">
        <div id="ltr1"></div>
        <div id="ltr2"></div>
        <div id="ltr3"></div>
      </div>
      <div class="rightToLeft">
        <div id="rtl1"></div>
        <div id="rtl2"></div>
        <div id="rtl3"></div>
      </div>
      <div class="topToBottom"></div>
      <div class="bottomToTop">
        <div id="btt1"></div>
        <div id="btt2"></div>
      </div>
      <img class="smallBall" src="../assets/small_ball.png"/>
      <img class="pinkBall" src="../assets/pink_ball.png"/>
      <img class="writeBall" src="../assets/write_ball.png"/>
      <img class="gridImg" src="../assets/grid2.png"/>
      <img class="conveText" src="../assets/conve_text2.png"  @touchstart="touchstart()" @touchmove="touchmove()" @touchend="touchend()"/>
      <img class="triangleImg" src="../assets/triangle2.png"/>
      <img class="wImg" src="../assets/w2.png"/>
      <img class="ballGif" src="../assets/ball_to_right.gif"  @touchstart="touchstart()" @touchmove="touchmove()" @touchend="touchend()"/>
    </div>
    <img class="selBacTop" v-if="!firstPage" src="../assets/gaokao_after/gaokao_after_top.png"/>
    <img class="selBacBottom" v-if="!firstPage" src="../assets/gaokao_after/gaokao_after_bottom.png"/>
    <div class="postPageSel" v-if="!firstPage">
      <div class="option" ref="opts" v-for="(item, index) in options" :key="index" @click="selectOption">
        <img class="optSelected" src="../assets/choosed.png" />
        <img class="optBac" :src="optBacImg[index]"/>
        <label v-if="item.slice(0,3) == '第一次'">第一次<br/>{{ item.slice(3) }}</label>
        <label v-else-if="item.slice(0,3) == '一个人'">一个人<br/>{{ item.slice(3) }}</label>
        <label v-else>{{ item }}</label>
      </div>
      <div class="optionAdd" @click="popPage = true">
        <img class="optBac" :src="optBacImg[8]"/>
        <p class="add">+</p>
        <label>自定义一件事</label>
      </div>
    </div>
    <button class="changeBtn" v-if="!firstPage" @click="changeOptions"></button>
    <button class="checkBtn" v-if="!firstPage" @click="checkPage = true">
      <img src="../assets/confirm_btn_left.png"/>
      查看
      <label class="checkNum">{{ checkNum }}</label>
    </button>
    <div class="popupContainer" v-show="popPage">
      <div class="mengBac" @click="popPage = false"></div>
      <div class="popup">
        <img class="popImg" src="../assets/close.png" @click="popPage = false"/>
        <div class="optionTitle">自定义事件</div>
        <input class="optionText" type="text" maxlength="8" placeholder="限8个字以内" v-model="custom" @focus="inputFocus" @blur="inputBlur"/>
        <button class="confirmBtn" @click="addOption"></button>
      </div>
    </div>
    <div class="popupContainer" v-show="checkPage">
      <div class="mengBac" @click="checkPage = false"></div>
      <div class="popup">
        <img class="popImg" src="../assets/close.png" @click="checkPage = false"/>
        <div class="checkContainer">
          <div class="checkOptions" v-for="(opt, index) in selected" :key="index">
            <img class="optDelete" src="../assets/close.png" @click="delOption" />
            <label>{{ opt }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FilterWord from '../store/keyWord.js'
export default {
  data () {
    return {
      firstPage: true,
      popPage: false,
      allOptions: [],
      options: [],
      selected: [],
      choosed: [],//已选择的
      appear: [],//已出现的
      checkPage: false,
      custom: '',//自定义名称
      checkNum: 0,
      bacNum: 1, //背景图片
      optBacImg: [
        require('../assets/gaokao_after/p1.png'),
        require('../assets/gaokao_after/p2.png'),
        require('../assets/gaokao_after/p3.png'),
        require('../assets/gaokao_after/p4.png'),
        require('../assets/gaokao_after/p5.png'),
        require('../assets/gaokao_after/p6.png'),
        require('../assets/gaokao_after/p7.png'),
        require('../assets/gaokao_after/p8.png'),
        require('../assets/gaokao_after/p9.png'),
      ]
    }
  },
  mounted () {
    this.allOptions = this.$store.getters.getAfterOptions
    this.$store.commit('clearAppear');
    this.options = this.allOptions[0]
    this.choosed = this.$store.getters.getChoosed
    this.appear = this.$store.getters.getAppear
  },
  methods: {
    randomsort(a, b) {
      return Math.random() > 0.5 ? -1 : 1;
    },
    changeOptions () {
      //打乱便签顺序
      let that = this
      this.optBacImg.sort(that.randomsort);
      // 保证之前出现的不会再出现
      if(this.appear != []){
        this.$store.commit('setAppear', this.options);
        this.appear = this.$store.getters.getAppear;
      }
      // 获取新选项并清空状态
      this.options = [];
      for(let i =0; i<8; i++){
        let opt = this.$refs.opts[i];
        let img = opt.firstElementChild
        if (img.style.display == 'block') {
          img.style.display = 'none';
        }
      }
      let j = [0, 1, 3, 7, 4, 5, 2, 6];
      let nums = [];
      let n = this.allOptions[1].length - 1;
      let k = 1;
      for(let i=0; i<8; i++){
        if(i === 4){
          nums = [];
          n = this.allOptions[2].length - 1;
          k = 2;
        }
        if(i === 6){
          nums = [];
          n = this.allOptions[3].length - 1;
          k = 3;
        }
        let randomNum = Math.round(Math.random() * n);
        let maxNum = 0;
        while(nums.indexOf(randomNum) > -1 || this.choosed.indexOf(this.allOptions[k][randomNum]) > -1 || this.appear.indexOf(this.allOptions[k][randomNum]) > -1) { 
          randomNum = Math.round(Math.random() * n); 
          if(maxNum>200) {
            this.$store.commit('clearAppear');
            this.appear = [];
            break;
          }
          else maxNum++;
        }
        nums.push(randomNum);
        this.options[j[i]] = this.allOptions[k][randomNum];
      }
    },
    addOption () {
      if(this.custom !== ''){
        if(FilterWord.filterWord(this.custom)){
          alert('内容包含敏感词汇');
          this.custom = ''
          return
        }
        this.selected.push(this.custom)
        this.custom = ''
        this.popPage = false;
        this.checkNum++;
        if(this.selected.length === 3) {
          this.$store.commit('setOptions', this.selected);
          this.$router.replace({path:'/write'})
        }
      }
    },
    selectOption (e) {
      let option = e.currentTarget;
      let index = this.$refs.opts.indexOf(option);
      let value = this.options[index];
      let img = option.firstElementChild;
      if (img.style.display == 'block') {
        img.style.display = 'none';
        this.checkNum--;
        index = this.selected.indexOf(value);
        this.$store.commit('updateAppear', value);
        this.selected.splice(index, 1);
      }
      else {
        if (this.selected.length < 3) {
          if(this.selected.indexOf(value) > -1 || this.choosed.indexOf(value) > -1){
            img.style.display = 'block';
            return
          }
          img.style.display = 'block';
          this.checkNum++;
          this.selected.push(value);
          //插入已出现
          this.$store.commit('setAppear', this.selected);
          this.appear = this.$store.getters.getAppear;
          if(this.selected.length === 3) {
            this.$store.commit('setOptions', this.selected);
            this.$router.replace({path:'/write'})
          }
        }
      }
    },
    delOption (e) {
      this.checkNum--;
      let img = e.currentTarget;
      let value = img.nextElementSibling.innerHTML;
      let index = this.selected.indexOf(value);
      this.selected.splice(index, 1);
      //消除选中图片
      index = this.options.indexOf(value);
      if(index > -1){
        img = this.$refs.opts[index].firstElementChild;
        if (img.style.display === 'block') {
          img.style.display = 'none';
        }
      }
    },
    touchstart() {
      event.preventDefault() //阻止默认事件（长按的时候出现复制
    },
    touchmove() { // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
      event.preventDefault()
      setTimeout(()=>{
        if(this.firstPage){
          this.firstPage = false
        }
      }, 500)
    },
    touchend () {
      event.preventDefault()
      setTimeout(()=>{
        if(this.firstPage){
          this.firstPage = false
        }
      }, 500)
    },
    inputFocus () {
      let bheight = document.getElementById('app').clientHeight;
      document.getElementsByClassName('container')[0].style.height = bheight + 'px';
    },
    inputBlur () {
      let bheight = document.getElementById('app').clientHeight;
      document.getElementsByClassName('container')[0].style.height = bheight + 'px';
      window.scroll(0,0);
    },
  }
}
</script>
<style scoped>
.container{
  width: 100%;
  height: 100%;
  margin:  0 auto;
  position: relative;
  overflow: hidden;
  background-color: #faeae7;
}
.postPage{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #bbdde7;
}
.postPageSel{
  width: 6.9rem;
  position: absolute;
  height: 8.1rem;
  top: 50%;
  left: 50%;
  transform: translate(-3.2rem, -4rem);
}
.selBacTop{
  width: 6.05rem;
  height: 1.61rem;
  position: absolute;
  top: 0.5rem;
  left: 50%;
  transform: translateX(-3.025rem);
}
.selBacBottom{
  width: 4.71rem;
  height: 1.38rem;
  position: absolute;
  bottom: 0.35rem;
  left: 50%;
  transform: translateX(-2.1rem);
}
.option{
  width: 2.18rem;
  height: 2.45rem;
  float: left;
  /* margin: 0 0.3rem 1.75rem 0.5rem; */
  position: relative;
  overflow: hidden;
}
.option label{
  display: block;
  width: 1.4rem;
  font-size: 0.27rem;
  line-height: 0.4rem;
  letter-spacing: 0.05rem;
  text-align: left;
  margin: 0.8rem auto 0;
  z-index: 5;
  position: relative;
}
.add{
  margin: 0.6rem auto 0;
  font-size: 0.5rem;
  text-align: center;
  z-index: 5;
  position: relative;
}
.optionAdd{
  width: 2.18rem;
  height: 2.45rem;
  float: left;
  overflow: hidden;
  position: relative;
}
.optionAdd label{
  display: block;
  width: 1.5rem;
  font-size: 0.23rem;
  line-height: 0.3rem;
  letter-spacing: 0.05rem;
  text-align: center;
  margin: 0 auto;
  z-index: 5;
  position: relative;
}
.optBac{
  width: 2.18rem;
  height: auto;
  position: absolute;
  bottom: 0;
  left: 0;
}
.changeBtn{
  appearance: none;
  width: 3.26rem;
  height: 0.91rem;
  background: url(../assets/change_btn.png) no-repeat;
  background-size: 100% 100%;
  display: block;
  padding: 0;
  outline: none;
  border: none;
  position: absolute;
  bottom: 1.4rem;
  left: 50%;
  transform: translateX(-1.63rem)
}
.changeBtn::after{
  content: '';
  width: 0.72rem;
  height: 0.25rem;
  position: absolute;
  bottom: 0.15rem;
  right: -0.36rem;
  background: url(../assets/confirm_btn_left.png) no-repeat;
  background-size: 100% 100%;
}
.checkBtn{
  appearance: none;
  height: 0.5rem;
  background-size: 100% 100%;
  display: block;
  padding: 0;
  outline: none;
  border: none;
  position: absolute;
  bottom: 1.4rem;
  left: 0.5rem;
  background: transparent;
}
.checkBtn img{
  width: 0.35rem;
  height: 0.25rem;
  margin-right: 0.05rem;
}
.checkNum{
  position: absolute;
  width: 0.3rem;
  height: 0.3rem;
  line-height: 0.3rem;
  display: inline-block;
  top: -0.2rem;
  right: -0.2rem;
  color: #fff;
  font-size: 0.2rem;
  border: 0.02rem solid #504e4a;
  border-radius: 50%;
  background-color: #d7594c;
}
.popupContainer{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mengBac{
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.popup{
  width: 6.24rem;
  height: 5.96rem;
  background: url(../assets/pop_up.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.confirmBtn{
  appearance: none;
  width: 3.26rem;
  height: 0.91rem;
  background: url(../assets/confirm_btn.png) no-repeat;
  background-size: 100% 100%;
  display: block;
  margin: 0.75rem auto 0;
  padding: 0;
  outline: none;
  border: none;
  position: relative;
}
.optionTitle{
  margin: 1.5rem auto 0;
  font-size: 0.35rem;
  line-height: 0.45rem;
  text-align: center;
  letter-spacing: 0.05rem;
}
.optionText{
  width: 4rem;
  margin: 0.6rem auto 0;
  font-size: 0.3rem;
  line-height: 0.45rem;
  display: block;
  appearance: none;
  background-color: transparent;
  border: none;
  outline: none;
  text-align: center;
  letter-spacing: 0.05rem;
  border-bottom: 0.02rem solid #504e4a;
}
.optSelected{
  width: 0.35rem;
  height: 0.35rem;
  position: absolute;
  right: 0.5rem;
  bottom: 0.4rem;
  display: none;
  z-index: 5;
}
.popImg{
  width: 0.48rem;
  height: 0.48rem;
  position: absolute;
  right: 0.2rem;
  top: 0.3rem;
}
.checkContainer{
  margin: 2rem auto 0;
}
.checkOptions{
  margin: 0.5rem auto;
  width: 4.5rem;
  height: 0.45rem;
  font-size: 0.33rem;
  line-height: 0.45rem;
}
.optDelete{
  width: 0.45rem;
  height: 0.45rem;
  float: right;
}
.smallBall{
  position: absolute;
  width: 0.3rem;
  height: 0.3rem;
  top: 5.15rem;
  right: 0.46rem;
}
.leftToRight div{
  width: 100%;
  height: 0.02rem;
  background-color: #000;
  position: absolute;
  animation: toright1 1s;
}
@keyframes toright1{
  0% {left: -7.5rem;}
  100% {left: 0;}
}
.leftToRight #ltr1{
  top: 1.9rem;
  left: 0;
}
.leftToRight #ltr2{
  top: 7.15rem;
  left: 0;
}
.leftToRight #ltr3{
  top: 9rem;
  left: 0;
}
.leftToRight2 #ltr4{
  left: 6.92rem;
  bottom: 3.85rem;
}
.leftToRight2 #ltr5{
  left: 6.92rem;
  bottom: 3.1rem;
}
.leftToRight2 #ltr6{
  left: 6.92rem;
  bottom: 2.35rem;
}
.rightToLeft div{
  position: absolute;
  height: 0.02rem;
  right: 0;
}
.rightToLeft #rtl1{
  width: 94%;
  height: 0.26rem;
  background: url(../assets/right_to_left.png) no-repeat;
  background-size: 100% 100%;
  top: 3.35rem;
  animation: toLeft1 1s;
}
@keyframes toLeft1{
  0% {right: -7.08rem;}
  100% {right: 0;}
}
.rightToLeft #rtl2{
  width: 1.35rem;
  height: 0.02rem;
  background: #000;
  top: 5.3rem;
  animation: toLeft2 1s;
}
@keyframes toLeft2{
  0% {right: -1.35rem;}
  100% {right: 0;}
}
.rightToLeft #rtl3{
  width: 7.5rem;
  height: 0.02rem;
  background: #000;
  bottom: 0.84rem;
  animation: toLeft3 1s;
}
@keyframes toLeft3{
  0% {right: -7.5rem;}
  100% {right: 0;}
}
.topToBottom{
  height: 100%;
  width: 0.02rem;
  background: #000;
  position: absolute;
  top: 0;
  left: 50%;
  animation: toBottom 1s;
}
@keyframes toBottom{
  0% {top: -100%;}
  100% {top: 0;}
}
.bottomToTop div{
  width: 0.23rem;
  height: 97%;
  position: absolute;
  bottom: 0;
  background: url(../assets/bottom_to_top.png) no-repeat;
  background-size: 100% 100%;
  animation: toTop 1s;
}
@keyframes toTop{
  0% {bottom: -13rem;}
  100% {bottom: 0;}
}
.bottomToTop #btt1{
  left: 1.2rem;
}
.bottomToTop #btt2{
  right: 0.45rem;
}
.gridImg{
  width: 4.12rem;
  height: 1.01rem;
  position: absolute;
  right: 0;
  bottom: 0;
  animation: gridShow 0.2s 1s;
  opacity: 0;
  animation-fill-mode:forwards;
}
@keyframes gridShow{
  0% {opacity: 0;}
  100% {opacity: 1;}
}
.conveText{
  width: 5.8rem;
  height: 7.61rem;
  position: absolute;
  left: 50%;
  transform: translateX(-2.9rem);
  top: 2rem;
  animation: gridShow 0.2s 1s;
  opacity: 0;
  animation-fill-mode:forwards;
}
.wImg{
  width: 2.18rem;
  height: 1.83rem;
  position: absolute;
  left: 0.57rem;
  bottom: -1.83rem;
  animation: wShow 1s 1.2s;
  animation-fill-mode:forwards;
}
@keyframes wShow{
  0% {left: 0.57rem;bottom: -1.83rem;}
  100% {left: 2.75rem;bottom: 0rem;}
}
.triangleImg{
  width: 0.76rem;
  height: 0.4rem;
  position: absolute;
  right: -0.76rem;
  bottom: -0.4rem;
  animation: triShow 1s 1.2s;
  animation-fill-mode:forwards;
}
@keyframes triShow{
  0% {right: -0.76rem;bottom: -0.4rem;}
  100% {right: 0.85rem;bottom: 0.68rem;}
}
.ballGif{
  width: 3.85rem;
  height: 2rem;
  position: absolute;
  top: 9rem;
  right: 0.54rem;
  animation: ballGifShow 0.2s 2.2s;
  opacity: 0;
  animation-fill-mode:forwards;
}
@keyframes ballGifShow{
  0% {opacity: 0;}
  100% {opacity: 1;}
}
.pinkBall{
  width: 0.66rem;
  height: 0.66rem;
  border-radius: 50%;
  position: absolute;
  left: 3.4rem;
  top: 1.5rem;
  z-index: 10;
  animation: beBigger 0.5s 2.4s;
  animation-fill-mode:forwards;
  transform: scale(0.3);
  opacity: 0;
}
.writeBall{
  width: 0.89rem;
  height: 0.89rem;
  border-radius: 50%;
  position: absolute;
  left: 0.83rem;
  bottom: 0.4rem;
  z-index: 10;
  animation: beBigger 0.5s 2.4s;
  animation-fill-mode:forwards;
  transform: scale(0.3);
  opacity: 0;
}
@keyframes beBigger {
  0% {transform: scale(0.3);opacity: 0;}
  100% {transform: scale(1);opacity: 1;}
}
</style>

